import React from 'react';
import _ from 'underscore';

import { ResponsePageNumbers, } from './responsePageNumbers'

import { requestGet } from '../../../../modules/request/index';
import { QuestionBar, ResponseList, ResponseSortFields, ResponseToggleFields, Spinner, hashToCollection, responsesWithStatus } from '../../index';

const qualityLabels = ['Human Optimal', 'Human Sub-Optimal', 'Algorithm Optimal', 'Algorithm Sub-Optimal', 'Unmatched'];
const colors = ['#81c784', '#ffb74d', '#BA68C8', '#5171A5', '#e57373'];
const responsesPerPage = 20;

class ResponsesManager extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      percentageOfWeakResponses: 0,
      selectedResponses: [],
      health: {},
      gradeBreakdown: {},
      enableRematchAllButton: true,
      isLoadingResponses: false,
      responses: props.storeResponsesLocally ? props.filters.responses : null,
    };
  }

  componentDidMount() {
    this.getNecessaryData();
  }

  componentDidUpdate(prevProps) {
    const { states, questionID, dispatch, filters, storeResponsesLocally, Constants } = this.props;

    const shouldReloadFlag = Constants.SHOULD_RELOAD_RESPONSES;
    const currentState = states && states[questionID];
    const prevState = prevProps.states && prevProps.states[prevProps.questionID];

    if (currentState === shouldReloadFlag && prevState !== shouldReloadFlag) {
      dispatch(this.props.questionActions.clearQuestionState(questionID));
      this.searchResponses();
    } else if (prevProps.questionID !== questionID) {
      this.getNecessaryData();
      this.unsubscribeToQuestion(prevProps.questionID);
    } else if (storeResponsesLocally && !_.isEqual(filters.responses, prevProps.filters.responses)) {
      this.setState({ responses: filters.responses });
    }
  }

  componentWillUnmount() {
    const { questionID } = this.props;
    this.unsubscribeToQuestion(questionID);
    this.clearResponses();
  }

  getNecessaryData = () => {
    const { questionID, dispatch } = this.props;
    this.searchResponses();
    this.getHealth();
    this.getGradeBreakdown();
    dispatch(this.props.questionActions.initializeSubscription(questionID));
  };

  unsubscribeToQuestion = (questionID) => {
    const { dispatch } = this.props;
    dispatch(this.props.questionActions.removeSubscription(questionID));
  };

  setResponsesLoaded = () => {
    this.setState({ isLoadingResponses: false });
  };

  getBoundsForCurrentPage = (length) => {
    const startIndex = (this.props.filters.responsePageNumber - 1) * responsesPerPage;
    const endIndex = startIndex + responsesPerPage > length ? length : startIndex + responsesPerPage;
    return [startIndex, endIndex];
  };

  getErrorsForAttempt = (attempt) => {
    return attempt.feedback;
  };

  getFilteredResponses = (responses) => {
    if (this.props.filters.stringFilter === '') {
      return responses;
    }
    const that = this;
    return _.filter(responses, (response) => response.text.indexOf(that.props.filters.stringFilter) >= 0);
  };

  getGradeBreakdown = () => {
    requestGet(`${window.postbuildEnv.QUILL_CMS}/questions/${this.props.questionID}/grade_breakdown`, (body) => {
      this.setState({
        gradeBreakdown: body,
      });
    });
  };

  getHealth = () => {
    requestGet(`${window.postbuildEnv.QUILL_CMS}/questions/${this.props.questionID}/health`, (body) => {
      this.setState({
        health: body,
      });
    });
  };

  getNumberOfPages = () => {
    return this.props.filters.numberOfPages;
  };

  getPercentageWeakResponses = () => {
    const { common_unmatched_responses, total_number_of_responses } = this.state.health;
    return common_unmatched_responses > 0 ? ((common_unmatched_responses / total_number_of_responses) * 100).toFixed(2) : 0.0;
  };

  getResponse = (responseID) => {
    const { storeResponsesLocally, filters } = this.props;
    const responses = storeResponsesLocally ? this.state.responses : filters.responses;
    return responses[responseID];
  };

  getResponseCount = () => {
    return this.state.health.total_number_of_responses;
  };

  getResponsesForCurrentPage = (responses) => {
    return responses;
  };

  getTotalAttempts = () => {
    return this.state.health.total_number_of_attempts;
  };

  allClosed = () => {
    const expanded = this.props.filters.expanded;
    for (const i in expanded) {
      if (expanded[i] === true) return false;
    }
    return true;
  };

  clearResponses = () => {
    this.props.dispatch(this.props.questionActions.updateResponses({ responses: [], numberOfResponses: 0, numberOfPages: 1, responsePageNumber: 1 }));
  };

  collapseAllResponses = () => {
    this.props.dispatch(this.props.filterActions.collapseAllResponses());
  };

  decrementPageNumber = () => {
    if (this.props.filters.responsePageNumber !== 1) {
      this.updatePageNumber(this.props.filters.responsePageNumber - 1);
    }
  };

  deselectFields = () => {
    this.props.dispatch(this.props.filterActions.deselectAllFields());
  };

  expand = (responseKey) => {
    this.props.dispatch(this.props.filterActions.toggleExpandSingleResponse(responseKey));
  };

  expandAllResponses = () => {
    const responses = this.responsesWithStatus();
    const newExpandedState = this.props.filters.expanded;
    for (let i = 0; i < responses.length; i++) {
      newExpandedState[responses[i].key] = true;
    }
    this.props.dispatch(this.props.filterActions.expandAllResponses(newExpandedState));
  };

  formatForQuestionBar = () => {
    const totalResponseCount = this.state.health.total_number_of_attempts;
    if (totalResponseCount === 0) {
      return [
        {
          value: 100,
          color: '#eeeeee',
        },
      ];
    }
    return _.mapObject(this.state.gradeBreakdown, (val, key) => ({
      value: (val / totalResponseCount) * 100,
      color: colors[qualityLabels.indexOf(key)],
    }));
  };

  gatherVisibleResponses = () => {
    return this.responsesWithStatus();
  };

  generateFeedbackString = (attempt) => {
    return this.getErrorsForAttempt(attempt);
  };

  handleSearchEnter = (e) => {
    if (e.key === 'Enter') {
      this.searchResponses();
    }
  };

  handleStringFiltering = (e) => {
    const { dispatch, questionID } = this.props;
    dispatch(this.props.questionActions.updateStringFilter(e.target.value, questionID));
  };

  rematchAllResponses = () => {
    this.setState({ enableRematchAllButton: false });
    const callback = (done) => {
      if (done) {
        this.searchResponses();
        this.getHealth();
        this.getGradeBreakdown();
      }
    };
    this.props.rematchAll(this.props.mode, this.props.questionID, callback);
  };

  rematchResponse = (rid) => {
    const { storeResponsesLocally, filters } = this.props;
    const responses = storeResponsesLocally ? this.state.responses : filters.responses;
    const response = responses[rid];
    const callback = this.searchResponses;
    this.props.rematchOne(response, this.props.mode, this.props.question, this.props.questionID, callback);
  };

  updateParentResponse = (id, response) => {
    const { storeResponsesLocally } = this.props;
    if (storeResponsesLocally) {
      const { responses } = this.state;
      responses[id] = response;
      this.setState({ responses });
    } else {
      this.searchResponses();
    }
  };

  removeResponseFromMassEditArray = (responseKey) => {
    this.props.dispatch(this.props.massEditActions.removeResponseFromMassEditArray(responseKey));
  };

  resetFields = () => {
    this.props.dispatch(this.props.filterActions.resetAllFields());
  };

  resetPageNumber = () => {
    this.updatePageNumber(1);
  };

  responsesByStatusCodeAndResponseCount = () => {
    return _.mapObject(this.responsesGroupedByStatus(), (val, key) => _.reduce(val, (memo, resp) => memo + (resp.count || 0), 0));
  };

  responsesGroupedByStatus = () => {
    return _.groupBy(this.responsesWithStatus(), 'statusCode');
  };

  responsesWithStatus = () => {
    const { storeResponsesLocally, filters } = this.props;
    const responses = storeResponsesLocally ? this.state.responses : filters.responses;
    return hashToCollection(responsesWithStatus(responses));
  };

  searchResponses = () => {
    const { dispatch, questionID } = this.props;

    this.setState({ isLoadingResponses: true });
    dispatch(this.props.questionActions.incrementRequestCount());
    dispatch(this.props.questionActions.searchResponses(questionID, this.setResponsesLoaded));
  };

  toggleExcludeMisspellings = () => {
    this.props.dispatch(this.props.filterActions.toggleExcludeMisspellings());
  };

  toggleFieldAndResetPage = (status) => {
    this.props.dispatch(this.props.filterActions.toggleStatusFieldAndResetPage(status));
  };

  toggleResponseSort = (field) => {
    this.props.dispatch(this.props.filterActions.toggleResponseSort(field));
  };

  updatePageNumber = (pageNumber) => {
    this.props.dispatch(this.props.questionActions.updatePageNumber(pageNumber));
    this.searchResponses();
  };

  updateRematchedResponse = (rid, vals) => {
    this.props.dispatch(this.props.submitResponseEdit(rid, vals, this.props.questionID));
  };

  incorrectSequenceNames = () => {
    const { question } = this.props;
    const { incorrectSequences } = question;

    let incorrectSequenceNames = [];
    if (Array.isArray(incorrectSequences)) {
      incorrectSequenceNames = incorrectSequences.map((i) => i.name);
    } else if (incorrectSequences) {
      incorrectSequenceNames = Object.keys(incorrectSequences).map((key) => incorrectSequences[key].name);
    }
    return incorrectSequenceNames.filter((f) => f !== undefined);
  };

  focusPointNames = () => {
    const { question } = this.props;
    const { focusPoints } = question;

    let focusPointNames = [];
    if (Array.isArray(focusPoints)) {
      focusPointNames = focusPoints.map((fp) => fp.name);
    } else if (focusPoints) {
      focusPointNames = Object.keys(focusPoints).map((key) => focusPoints[key].name);
    }
    return focusPointNames.filter((f) => f !== undefined);
  };

  renderDeselectAllFiltersButton = () => {
    return (
      <div className="column">
        <button className="button is-fullwidth is-outlined" onClick={this.deselectFields} type="button">
          Deselect All Filters
        </button>
      </div>
    );
  };

  renderDisplayingMessage = () => {
    const { filters } = this.props;
    const length = filters.numberOfResponses;
    const bounds = this.getBoundsForCurrentPage(filters.numberOfResponses);
    const message = `Displaying ${bounds[0] + 1}-${bounds[1]} of ${length} responses`;
    return <p className="label">{message}</p>;
  };

  renderExpandCollapseAll = () => {
    let text, handleClick;

    if (this.allClosed()) {
      handleClick = this.expandAllResponses;
      text = 'Expand';
    } else {
      handleClick = this.collapseAllResponses;
      text = 'Close';
    }
    return (
      <a className="button is-fullwidth" onClick={handleClick}>
        {text}
      </a>
    );
  };

  renderPageNumbers = () => {
    const { filters, } = this.props
    return (
      <ResponsePageNumbers
        numberOfPages={filters.numberOfPages || 0}
        responsePageNumber={filters.responsePageNumber}
        updatePageNumber={this.updatePageNumber}
      />
    )
  };

  renderRematchAllButton = () => {
    const { filters, admin } = this.props;
    const { progress, enableRematchAllButton } = this.state;

    if (admin) {
      const text = progress ? `${progress}%` : 'Rematch Responses';

      return (
        <button
          className="button is-outlined is-danger"
          disabled={!enableRematchAllButton}
          onClick={this.rematchAllResponses}
          style={{ float: 'right' }}
          type="button"
        >
          {text}
        </button>
      );
    }
  };

  renderResetAllFiltersButton = () => {
    return (
      <div className="column">
        <button className="button is-fullwidth is-outlined" onClick={this.resetFields} type="button">
          Select All Filters
        </button>
      </div>
    );
  };

  renderResponses = () => {
    const { isLoadingResponses } = this.state;

    if (isLoadingResponses) {
      return (
        <div className="loading-spinner-container">
          <Spinner />
        </div>
      );
    }

    const { questionID, selectedIncorrectSequences, selectedFocusPoints, storeResponsesLocally } = this.props;
    const responsesWStatus = this.responsesWithStatus();
    const responses = storeResponsesLocally ? _.sortBy(hashToCollection(responsesWStatus), 'sortOrder') : _.sortBy(responsesWStatus, 'sortOrder');
    return (
      <ResponseList
        addResponsesToMassEditArray={this.props.massEditActions.addResponsesToMassEditArray}
        admin={this.props.admin}
        ascending={this.props.filters.ascending}
        conceptID={this.props.question.conceptID}
        concepts={this.props.concepts}
        conceptsFeedback={this.props.conceptsFeedback}
        Constants={this.props.Constants}
        deleteResponse={this.props.deleteResponse}
        dispatch={this.props.dispatch}
        expand={this.expand}
        expanded={this.props.filters.expanded}
        getGradedResponsesWithCallback={this.props.getGradedResponsesWithCallback}
        getMatchingResponse={this.rematchResponse}
        getResponse={this.getResponse}
        massEdit={this.props.massEdit}
        massEditActions={this.props.massEditActions}
        mode={this.props.mode}
        question={this.props.question}
        questionActions={this.props.questionActions}
        questionID={questionID}
        rematchOne={this.props.rematchOne}
        removeResponsesFromMassEditArray={this.props.massEditActions.removeResponsesFromMassEditArray}
        responses={responses}
        selectedFocusPoints={selectedFocusPoints}
        selectedIncorrectSequences={selectedIncorrectSequences}
        states={this.props.states}
        submitResponseEdit={this.props.submitResponseEdit}
        updateParentResponse={this.updateParentResponse}
      />
    );
  };

  renderSortingFields = () => {
    return <ResponseSortFields ascending={this.props.filters.ascending} sorting={this.props.filters.sorting} toggleResponseSort={this.toggleResponseSort} />;
  };

  renderStatusToggleMenu = () => {
    let usedQualityLabels = qualityLabels;
    const { mode, filters, Constants } = this.props;
    const { visibleStatuses } = filters;
    const regexLabels = this.incorrectSequenceNames().concat(this.focusPointNames());

    if (mode === 'questions') {
      usedQualityLabels = _.without(qualityLabels, 'Algorithm Optimal');
    }

    const labels = Constants.ERROR_AUTHORS;

    return (
      <ResponseToggleFields
        deselectFields={this.deselectFields}
        excludeMisspellings={this.props.filters.formattedFilterData.filters.excludeMisspellings}
        labels={labels}
        qualityLabels={usedQualityLabels}
        regexLabels={regexLabels}
        resetFields={this.resetFields}
        resetPageNumber={this.resetPageNumber}
        toggleExcludeMisspellings={this.toggleExcludeMisspellings}
        toggleFieldAndResetPage={this.toggleFieldAndResetPage}
        visibleStatuses={visibleStatuses}
      />
    );
  };

  showResults = () => {
    this.searchResponses();
  };

  renderShowResultsButton = () => {
    return (
      <div className="show-results-container">
        <a className="button is-outlined is-primary search" onClick={this.showResults}>
          Show Results
        </a>
      </div>
    );
  };

  render() {
    const { filters, mode } = this.props;
    const { responses, stringFilter } = filters;
    const questionBar = responses && Object.keys(responses).length > 0 ? <QuestionBar data={_.values(this.formatForQuestionBar())} /> : <span />;

    return (
      <div style={{ marginTop: 0, paddingTop: 0 }}>
        {questionBar}
        {this.renderRematchAllButton()}
        <h4 className="title is-5">
          Overview - Total Attempts: <strong>{this.getTotalAttempts()}</strong> | Unique Responses: <strong>{this.getResponseCount()}</strong> | Percentage of weak
          responses: <strong>{this.getPercentageWeakResponses()}%</strong>
        </h4>
        <div className="filters-and-sorting-container">
          <div className="tabs is-toggle is-fullwidth">{this.renderStatusToggleMenu()}</div>
          <div className="columns">
            <div className="column">
              <div className="tabs is-toggle is-fullwidth">{this.renderSortingFields()}</div>
            </div>
            <div className="column">
              <div className="columns">
                <div className="column">{this.renderExpandCollapseAll()}</div>
                {this.renderResetAllFiltersButton()}
                {this.renderDeselectAllFiltersButton()}
              </div>
            </div>
          </div>
          <div className="search-container">
            <input className="input" onChange={this.handleStringFiltering} onKeyPress={this.handleSearchEnter} placeholder="Enter a search term or /regular expression/" type="text" value={stringFilter} />
          </div>
        </div>
        {this.renderShowResultsButton()}
        {this.renderDisplayingMessage()}
        {this.renderPageNumbers()}
        {this.renderResponses()}
        {this.renderPageNumbers()}
      </div>
    );
  }
}

export default ResponsesManager;
